import React from 'react';
import { useObserver } from '../../CodesThatsGottaGoSomewhereElse';
import { useResolve } from '../Container';
import { AccountModel } from '../account/AccountModel';
import { Copy, Flexer, LinkButton, Spacer, Title } from '../dashboard/elements/LayoutElements';

export const TeamView = () => {

    const account = useObserver(useResolve(AccountModel));

    return <Flexer width="32">
        <Copy>Your are currently a member of:</Copy>
        <Title flush>{account.label}</Title>
        <Spacer f={2} />
        <LinkButton href={'/account/close'} variant="negative">Delete your profile</LinkButton>
    </Flexer>;
};
